var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.065 0H0.935C0.687023 0 0.449202 0.0985087 0.273855 0.273855C0.0985087 0.449202 0 0.687023 0 0.935V16.065C0 16.313 0.0985087 16.5508 0.273855 16.7261C0.449202 16.9015 0.687023 17 0.935 17H9.078V10.4125H6.868V7.8625H9.078V5.95C9.03222 5.50099 9.08523 5.04741 9.23331 4.62106C9.38139 4.19471 9.62095 3.80591 9.9352 3.48195C10.2494 3.15799 10.6308 2.90669 11.0524 2.7457C11.474 2.58471 11.9258 2.51791 12.376 2.55C13.0376 2.54593 13.6988 2.57999 14.3565 2.652V4.947H13.005C11.934 4.947 11.73 5.457 11.73 6.1965V7.837H14.28L13.9485 10.387H11.73V17H16.065C16.1878 17 16.3094 16.9758 16.4228 16.9288C16.5362 16.8818 16.6393 16.813 16.7261 16.7261C16.813 16.6393 16.8818 16.5362 16.9288 16.4228C16.9758 16.3094 17 16.1878 17 16.065V0.935C17 0.812214 16.9758 0.69063 16.9288 0.577191C16.8818 0.463752 16.813 0.360678 16.7261 0.273855C16.6393 0.187032 16.5362 0.118161 16.4228 0.0711727C16.3094 0.0241846 16.1878 0 16.065 0Z",
    fill: "#B3CFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceebook);
export default __webpack_public_path__ + "static/media/faceebook.eac76b32c165600add53fccf9ec98141.svg";
export { ForwardRef as ReactComponent };